import { useEffect, useState } from "react";
import { server } from "../../server";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { monthsList } from "../../utils";
import { getDecodedToken } from "../../auth";

function UpdateScholarship() {
  const [error, setError] = useState(null);
  const { state } = useLocation();
  const admissionNo = state?.admissionNo;
  const [studentData, setStudentData] = useState(null);
  const [siblingAdmissionNos, setSiblingAdmissionNos] = useState([]);
  const [staffId, setStaffId] = useState("");
  const [newSiblingAdmissionNo, setNewSiblingAdmissionNo] = useState("");
  const [formData, setFormData] = useState({
    scholarship: {
      type: "",
      siblingAdmissionNo: [],
      staffId: "",
      scholarshipFrom: "",
      remark: "",
      discount: {
        admissionFee: 0,
        monthlyFee: 0,
        developmentFee: 0,
      },
    },
  });

  useEffect(() => {
    const fetchStudent = async () => {
      if (!admissionNo) {
        setError("Please enter Admission No");
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(
          `${server}/getParticularStudentMongodb`,
          { admission_no: admissionNo },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        const studentData = response.data?.["body-json"]?.body?.student;
        if (studentData) {
          setStudentData(studentData);
        } else {
          setError("No Student Data Found");
          setStudentData(null);
        }
      } catch (err) {
        setError("Student not found or API error.");
        setStudentData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [admissionNo]);

  useEffect(() => {
    if (studentData) {
      setFormData((prev) => ({
        ...prev,
        scholarship: {
          ...studentData.scholarship,
          siblingAdmissionNo: studentData.scholarship?.siblingAdmissionNo || [],
        },
      }));
    }
  }, [studentData]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const decodedData = getDecodedToken();
    if (decodedData) {
      setUser(decodedData);
    }
  }, []);

  const handleChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleScholarshipChange = (e) => {
    const { name, value } = e.target;
    const numericFields = ["admissionFee", "monthlyFee", "developmentFee"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/\D/g, "") || "0"
      : value;

    setFormData((prev) => {
      let updatedScholarship = { ...prev.scholarship };

      if (name === "type") {
        updatedScholarship = {
          type: updatedValue,
          siblingAdmissionNo: [],
          staffId: "",
          scholarshipFrom: "",
          remark: "",
          discount: {
            admissionFee: 0,
            monthlyFee: 0,
            developmentFee: 0,
          },
        };
        setSiblingAdmissionNos([]);
        setStaffId("");
      } else if (numericFields.includes(name)) {
        updatedScholarship.discount = {
          ...updatedScholarship.discount,
          [name]: updatedValue,
        };
      } else {
        updatedScholarship[name] = updatedValue;
      }

      return { ...prev, scholarship: updatedScholarship };
    });
  };

  const addSiblingAdmissionNo = () => {
    if (
      newSiblingAdmissionNo &&
      formData.scholarship?.siblingAdmissionNo?.length < 5
    ) {
      setFormData((prev) => ({
        ...prev,
        scholarship: {
          ...prev.scholarship,
          siblingAdmissionNo: [
            ...(prev.scholarship.siblingAdmissionNo || []),
            newSiblingAdmissionNo,
          ],
        },
      }));

      setNewSiblingAdmissionNo("");
    }
  };

  const removeSiblingAdmissionNo = (index) => {
    setFormData((prevFormData) => {
      const updatedSiblingAdmissionNo = Array.isArray(
        prevFormData.scholarship?.siblingAdmissionNo,
      )
        ? prevFormData.scholarship.siblingAdmissionNo.filter(
            (_, i) => i !== index,
          )
        : [];

      return {
        ...prevFormData,
        scholarship: {
          ...prevFormData.scholarship,
          siblingAdmissionNo: updatedSiblingAdmissionNo,
        },
      };
    });
  };

  const addEmployeeId = () => {
    if (!staffId && formData.scholarship?.staffId) {
      setStaffId(formData.scholarship.staffId);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Remark is required only when Ward Type is "Other"
    if (
      formData.scholarship?.type === "other" &&
      !formData.scholarship?.remark?.trim()
    ) {
      toast.error("Remark is required for Other scholarship type", {
        position: "top-right",
      });
      return;
    }

    setLoading(true);

    const rawScholarship = formData.scholarship;
    let scholarship = {
      type: rawScholarship.type,
      scholarshipFrom: rawScholarship.scholarshipFrom,
    };

    if (rawScholarship.type === "sibling") {
      if (rawScholarship.siblingAdmissionNo?.length) {
        scholarship.siblingAdmissionNo = rawScholarship.siblingAdmissionNo;
      }
    } else if (rawScholarship.type === "staff") {
      // ✅ FIX: Always include staffId for staff type (from formData OR local staffId state)
      const finalStaffId = rawScholarship.staffId || staffId;
      if (finalStaffId) {
        scholarship.staffId = finalStaffId;
      }

      // Also include discount fees if any are set for staff
      const discount = rawScholarship.discount || {};
      const filteredFees = {};
      ["admissionFee", "monthlyFee", "developmentFee"].forEach((feeKey) => {
        const feeValue = parseInt(discount[feeKey]);
        if (!isNaN(feeValue) && feeValue > 0) {
          filteredFees[feeKey] = feeValue;
        }
      });

      if (Object.keys(filteredFees).length > 0) {
        scholarship.discount = filteredFees;
      }
    } else if (rawScholarship.type === "other") {
      const discount = rawScholarship.discount || {};
      const filteredFees = {};
      ["admissionFee", "monthlyFee", "developmentFee"].forEach((feeKey) => {
        const feeValue = parseInt(discount[feeKey]);
        if (!isNaN(feeValue) && feeValue > 0) {
          filteredFees[feeKey] = feeValue;
        }
      });

      if (Object.keys(filteredFees).length > 0) {
        scholarship.discount = filteredFees;
      }

      // Remark applies only to "other" type
      scholarship.remark = rawScholarship.remark.trim();
    }

    try {
      const response = await axios.post(
        `${server}/update_scholarship_mongodb`,
        {
          admission_no: admissionNo,
          scholarship,
          updatedBy: user?.userId,
        },
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      toast.success("Scholarship Details Updated", { position: "top-right" });
      navigate("/student-details");
    } catch (error) {
      console.error("Scholarship API Error:", error);
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Update Scholarship</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Student Information</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Student Details</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Update Scholarship
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <form onSubmit={handleSubmit}>
                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div>
                        <div>
                          <h3 class="m-0 fs-list">
                            <div class="d-flex align-items-center text-inherit">
                              <span class="me-auto fs-5">Scholarship</span>
                              <div className="d-flex align-items-center">
                                <span className="badge px-3 bg-info-soft">
                                  If Eligible
                                </span>
                              </div>
                            </div>
                          </h3>

                          <div>
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Ward Type
                                </label>
                                <Select
                                  options={[
                                    { label: "Sibling", value: "sibling" },
                                    {
                                      label: "Staff Child",
                                      value: "staff",
                                    },
                                    { label: "Other", value: "other" },
                                  ]}
                                  value={
                                    formData.scholarship?.type
                                      ? {
                                          label:
                                            formData.scholarship.type ===
                                            "sibling"
                                              ? "Sibling"
                                              : formData.scholarship.type ===
                                                  "staff"
                                                ? "Staff Child"
                                                : "Other",
                                          value: formData.scholarship.type,
                                        }
                                      : null
                                  }
                                  onChange={(selected) =>
                                    handleScholarshipChange({
                                      target: {
                                        name: "type",
                                        value: selected?.value || "",
                                      },
                                    })
                                  }
                                  placeholder="Select Scholarship Type"
                                  classNamePrefix="react-select"
                                  className={`text-dark ${
                                    errors?.scholarship?.type
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  isClearable
                                />
                              </div>

                              {formData.scholarship?.type === "sibling" && (
                                <>
                                  <div className="col-lg-6 col-12"></div>
                                  <div className="col-lg-6 col-12">
                                    <label className="form-label mb-1 ms-3">
                                      Sibling Admission No.
                                    </label>

                                    <input
                                      type="text"
                                      className={`form-control text-dark ${
                                        errors?.scholarship?.siblingAdmissionNo
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      name="siblingAdmissionNo"
                                      value={newSiblingAdmissionNo}
                                      onChange={(e) =>
                                        setNewSiblingAdmissionNo(e.target.value)
                                      }
                                      maxLength={5}
                                    />

                                    <span
                                      className="btn btn-danger px-5 mt-3 mb-3 fs-6 fw-semibold rounded-pill cursor-pointer"
                                      onClick={addSiblingAdmissionNo}
                                      disabled={
                                        formData.scholarship?.siblingAdmissionNo
                                          ?.length >= 5
                                      }
                                    >
                                      Add Sibling
                                      <i className="bi bi-plus-circle-fill ms-2"></i>
                                    </span>
                                  </div>
                                </>
                              )}

                              {formData.scholarship?.type === "staff" && (
                                <>
                                  <div className="col-lg-6 col-12"></div>
                                  <div className="col-lg-6 col-12">
                                    <label class="form-label mb-1 ms-3">
                                      Staff ID
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control text-dark ${
                                        errors?.scholarship?.staffId
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      name="staffId"
                                      value={
                                        formData.scholarship?.staffId || ""
                                      }
                                      onChange={handleScholarshipChange}
                                    />
                                    <span
                                      class="btn btn-danger px-5 mt-3 mb-3 fs-6 fw-semibold rounded-pill cursor-pointer"
                                      onClick={addEmployeeId}
                                      disabled={!!staffId}
                                    >
                                      Add Staff
                                      <i className="bi bi-plus-circle-fill ms-2"></i>
                                    </span>
                                  </div>
                                </>
                              )}

                              {formData.scholarship?.type === "other" && (
                                <>
                                  <div className="col-lg-6 col-12">
                                    <label className="form-label mb-1 ms-3">
                                      Remark{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                      className={`form-control text-dark ${
                                        errors?.scholarship?.remark
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      name="remark"
                                      placeholder="Enter reason for this scholarship/discount"
                                      value={formData.scholarship?.remark || ""}
                                      onChange={handleScholarshipChange}
                                      rows="4"
                                      required
                                    />
                                  </div>
                                  <div className="col-lg-6 col-12">
                                    <label className="form-label mb-1 ms-3">
                                      Admission Fee
                                    </label>
                                    <input
                                      type="number"
                                      className={`form-control text-dark ${
                                        errors?.scholarship?.admissionFee
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      name="admissionFee"
                                      placeholder="Enter Admission Fee"
                                      value={
                                        formData.scholarship?.discount
                                          ?.admissionFee || ""
                                      }
                                      onChange={handleScholarshipChange}
                                    />
                                  </div>
                                  <div className="col-lg-6 col-12">
                                    <label className="form-label mb-1 ms-3">
                                      Monthly Fee
                                    </label>
                                    <input
                                      type="number"
                                      className={`form-control text-dark ${
                                        errors?.scholarship?.monthlyFee
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      name="monthlyFee"
                                      placeholder="Enter Monthly Fee"
                                      value={
                                        formData.scholarship?.discount
                                          ?.monthlyFee || ""
                                      }
                                      onChange={handleScholarshipChange}
                                    />
                                  </div>
                                  <div className="col-lg-6 col-12">
                                    <label className="form-label mb-1 ms-3">
                                      Development Fee
                                    </label>
                                    <input
                                      type="number"
                                      className={`form-control text-dark ${
                                        errors?.scholarship?.developmentFee
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      name="developmentFee"
                                      placeholder="Enter Development Fee"
                                      value={
                                        formData.scholarship?.discount
                                          ?.developmentFee || ""
                                      }
                                      onChange={handleScholarshipChange}
                                    />
                                  </div>
                                </>
                              )}

                              <div className="col-lg-6 col-12 d-flex justify-content-end align-items-center">
                                <div className="d-flex flex-column ms-3">
                                  {Array.isArray(
                                    formData.scholarship?.siblingAdmissionNo,
                                  ) ? (
                                    formData.scholarship.siblingAdmissionNo.map(
                                      (no, index) => (
                                        <h5
                                          className="px-3 lh-sm m-0 text-dark rounded-pill d-flex justify-content-between"
                                          key={index}
                                        >
                                          {no}
                                          <i
                                            className="bi bi-x-circle-fill ms-3 text-secondary cursor-pointer"
                                            onClick={() =>
                                              removeSiblingAdmissionNo(index)
                                            }
                                          ></i>
                                        </h5>
                                      ),
                                    )
                                  ) : formData.scholarship
                                      ?.siblingAdmissionNo ? (
                                    <h5 className="px-3 lh-sm m-0 text-dark rounded-pill d-flex justify-content-between">
                                      {formData.scholarship.siblingAdmissionNo}
                                      <i
                                        className="bi bi-x-circle-fill ms-3 text-secondary cursor-pointer"
                                        onClick={() =>
                                          removeSiblingAdmissionNo(0)
                                        }
                                      ></i>
                                    </h5>
                                  ) : null}

                                  {staffId && (
                                    <h5 className="px-3 lh-sm m-0 text-dark rounded-pill d-flex justify-content-between">
                                      {staffId}
                                      <i
                                        className="bi bi-x-circle-fill ms-3 text-secondary cursor-pointer"
                                        onClick={() => setStaffId("")}
                                      ></i>
                                    </h5>
                                  )}
                                </div>
                              </div>

                              {formData.scholarship?.type && (
                                <div className="col-lg-6 col-12">
                                  <label class="form-label mb-1 ms-3">
                                    Scholarship From
                                  </label>
                                  <Select
                                    options={monthsList.map((month) => ({
                                      label: month,
                                      value: month,
                                    }))}
                                    value={
                                      formData.scholarship?.scholarshipFrom
                                        ? {
                                            label:
                                              formData.scholarship
                                                .scholarshipFrom,
                                            value:
                                              formData.scholarship
                                                .scholarshipFrom,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      handleScholarshipChange({
                                        target: {
                                          name: "scholarshipFrom",
                                          value: selected?.value || "",
                                        },
                                      })
                                    }
                                    placeholder="Select Month"
                                    classNamePrefix="react-select"
                                    className={`text-dark ${
                                      errors?.scholarship?.scholarshipFrom
                                        ? "border-danger"
                                        : ""
                                    }`}
                                    isClearable
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button type="submit" class="btn btn-success mt-2 px-6">
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Update"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-lg-4">
                  {studentData && (
                    <div className="sticky-top top-10 z-1 ">
                      <div className="p-5 bg-white rounded-4">
                        <div className="d-flex flex-column align-items-center">
                          <div>
                            <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative overflow-hidden me-2">
                              <img
                                src={
                                  studentData?.studentDetails?.studentImage ||
                                  `/assets/images/profile.png`
                                }
                                alt="Image"
                                width="150"
                                height="150"
                                className="object-fit-cover rounded-3"
                              />
                            </div>
                            <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                              <img
                                src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                                className="w-100 position-absolute p-2 rounded-4"
                                alt="QR"
                              />
                            </div>
                          </div>
                          <div className="mt-3 text-center">
                            <h3 class="m-0 fs-4 lh-sm">
                              {studentData?.studentDetails?.name
                                .toLowerCase()
                                .replace(/\b\w/g, (char) =>
                                  char.toUpperCase(),
                                )}{" "}
                              ({studentData?.currentClass},{" "}
                              {studentData?.studentDetails?.currentSection})
                            </h3>
                            <p className="m-0">
                              {studentData?.studentDetails?.admission_no},{" "}
                              {new Date(
                                studentData?.studentDetails?.admissionDate,
                              ).toLocaleDateString("en-GB")}
                            </p>
                            <p className="mt-3 mb-0 text-danger lh-sm">
                              (+91) {studentData?.parentDetails[0]?.phone}
                              <br />
                              <span className="text-lowercase">
                                {studentData?.parentDetails[0]?.email}
                              </span>
                            </p>
                            <p className="m-0 lh-sm mt-4 text-capitalize">
                              {studentData?.presentAddress?.address
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                              <br />
                              {studentData?.presentAddress?.city} -{" "}
                              {studentData?.presentAddress?.state}
                            </p>
                            <p className="mt-3 mb-0 text-dark lh-sm">
                              Mr.{" "}
                              {studentData?.parentDetails[0]?.name
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                              <br />
                              Mrs.{" "}
                              {studentData?.parentDetails[1]?.name
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default UpdateScholarship;
